import React, {useState, useEffect} from 'react';
import { useForm, SubmitHandler } from "react-hook-form"
import { useTranslation } from 'react-i18next';
import { bookingCreditCard }  from "./server/bookingCreditCard";
import { bookingSecureCreditCard }  from "./server/bookingSecureCreditCard";
import { bookingPayPal }  from "./server/bookingPayPal";
import { bookingBizum }  from "./server/bookingBizum";
import { bookingGooglePay }  from "./server/bookingGooglePay";
import EMDBcart from  '../../utils/emdb.cart.js'

//Images
import imgPaypal from './assets/paypal_big.webp';
import imgCreditcard from './assets/creditcard_big.webp';
import imgBizum from './assets/bizum_big.webp';
import imgGooglePay from './assets/googlepay_big.webp';

//CSS
import styles from './VTCartForm.module.less';

function VTCartForm({config}) {
  const debug =  config.hasOwnProperty('debug') ? config.debug : false
  const [cart, setCart] = useState(new EMDBcart('vtformcart'));
  const [loading, setLoading] = useState(false);
  const {t,i18n} = useTranslation(["vtcartform"]);
  const language = (config.hasOwnProperty('locale')) ? config.locale : 'es';
  const numProducts = cart.getNumProducts();

  const initialValues = process.env.NODE_ENV ==='development' ?
    {
      name:"zana",
      surname:"vega",
      mail1:"elmonstrodelbunker@gmail.com",
      mail2:"elmonstrodelbunker@gmail.com",
      phone:"677414545",
      room:"prueba",
      observations:"Esto es una prueba",
    }
    :null;

  const {
    register,
    unregister,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError
  } = useForm({defaultValues: initialValues});

  const paymethod = watch('paymethod');

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    //Cargamos GOOGLE PAY
    const script = document.createElement('script');
    script.src = "https://pay.google.com/gp/p/js/pay.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
  }, []);

  useEffect(() => {
    //Comprobamos evento Storage para saber si se actualizo el carro
    const handleStorage = () => {
      //Actualizamos el objeto con el carro
      setCart(new EMDBcart('vtformcart'));
    }
    document.addEventListener('storage', handleStorage)
    return () => document.removeEventListener('storage', handleStorage)
  }, [])

  useEffect(() => {
    if (paymethod === 'creditcard') {
      register("creditcard");
      register("month");
      register("year");
      register("cvv");
      register("namecreditcard");
      
      if(process.env.NODE_ENV ==='development'){
          setValue("creditcard","4548 8120 4940 0004");
          //setValue("creditcard","4918 0191 6003 4602");  //Frictionless
          setValue("month","10");
          setValue("year","28");
          setValue("cvv","123");
          setValue("namecreditcard","javier vega");
      }

    } else {
      unregister("creditcard");
      unregister("month");
      unregister("year");
      unregister("cvv");
      unregister("namecreditcard");
    }
  }, [paymethod]);


  const onSubmit =  handleSubmit(async (data) => {
    if (config.debug) console.log("SUBMIT");

    data['amount']=cart.getCartAmount();
    data['promotion']=0;

    if (paymethod === "creditcard"){
      if (config.debug) console.log("Iniciando pago creditcard");
      data['creditcard']=data['creditcard'].replace(/ /g, "");
      setLoading('creditcard');

      const response = await bookingCreditCard (cart.getCartProducts(), data, config.merchantURL, debug);
      if (debug) console.log(response);

      if(!response.error) {
        if (response.data.needauthentication) {
          //Necesita autentificacion
          if (debug) console.log('Necesita autentificacion');
          //Adjuntamos formulario y hacemos submit
          document.getElementById("root").insertAdjacentHTML('afterend', response.data.form);
          document.getElementById(response.data.nameform).submit();
        } else {
          //Pago por  Frictionless. pago ya realizado (redireccionamos a final-booking)
          window.location.href = config.merchantURL + '/final-booking?transactionID='+response.data.bookingresponse.pay.idtransaction;
        }
      }else{
        //Error o cancelacion de la operacion
        if (debug) console.log ("##### ERROR CREDIT CARD #####");
        if (debug) console.log ("ERROR CODE: " +response.error.code);
        if (debug) console.log ("ERROR MSG: " + response.error.msg);
        if (debug) console.log ("ERROR TPVERROR: " + response.error.tpverror);
        if (debug) console.log ("ERROR TPVMAG: " + response.error.tpvmsg);

        setLoading(false);
        setError("namecreditcard", { message: "[" + response.error.code + "] " + response.error.msg })
        if (response.error.tpverror !== undefined) setError("creditcard", { message: "[" + response.error.tpverror + "] " + response.error.tpvmsg })

      }
    }else if (paymethod === "securecreditcard"){
      if (debug) console.log("Iniciando pago securecreditcard");

      setLoading('securecreditcard');
      const response = await bookingSecureCreditCard (cart.getCartProducts(), data, config.merchantURL, debug);
      if (debug) console.log(response);

      if(!response.error) {
        let form = document.createElement('form');
        form.method = "POST";
        form.action = response.data.redirectURL;
        let inputDS_SignatureVersion = document.createElement('input');
        inputDS_SignatureVersion.type = 'text';
        inputDS_SignatureVersion.name = 'DS_SignatureVersion';
        inputDS_SignatureVersion.value = response.data.formparameters.Ds_SignatureVersion;
        let inputDs_MerchantParameters = document.createElement('input');
        inputDs_MerchantParameters.type = 'text';
        inputDs_MerchantParameters.name = 'Ds_MerchantParameters';
        inputDs_MerchantParameters.value = response.data.formparameters.Ds_MerchantParameters;
        let inputDS_Signature = document.createElement('input');
        inputDS_Signature.type = 'text';
        inputDS_Signature.name = 'DS_Signature';
        inputDS_Signature.value = response.data.formparameters.Ds_Signature;

        form.appendChild(inputDS_SignatureVersion);
        form.appendChild(inputDs_MerchantParameters);
        form.appendChild(inputDS_Signature);

        document.body.appendChild(form);
        form.submit();
      }else{
        if (debug) console.log ("[ERROR]: En peticion pago tarjeta seguro");
        if (debug) console.log ("ERROR: " + response.error.code);
        await 1;
      }
    }else if (paymethod === "paypal"){
      if (debug) console.log("Iniciando pago paypal");

      setLoading('paypal');
      const response = await bookingPayPal (cart.getCartProducts(),data);
      if (debug) console.log(response);

      if(!response.error) {
        location.href =response.data.pay.URL;
      }else{
        {/* FALA COMPROBAR ESTE CASO*/}
        if (debug) console.log("ERROR:", response.error.code);
        await 1;
      }
    }else if (paymethod === "bizum"){
      if (debug) console.log("Iniciando pago bizum");
      setLoading('bizum');

      const response = await bookingBizum (cart.getCartProducts(), data, config.merchantURL, debug);
      if (debug) console.log(response);
      if (debug) console.log(response.data.redirectURL);

      if(!response.error) {
        let formBizum = document.createElement('form');
        formBizum.method = "POST";
        formBizum.action = response.data.redirectURL;
        let inputDS_SignatureVersion = document.createElement('input');
        inputDS_SignatureVersion.type = 'text';
        inputDS_SignatureVersion.name = 'DS_SignatureVersion';
        inputDS_SignatureVersion.value = response.data.formparameters.Ds_SignatureVersion;
        let inputDs_MerchantParameters = document.createElement('input');
        inputDs_MerchantParameters.type = 'text';
        inputDs_MerchantParameters.name = 'Ds_MerchantParameters';
        inputDs_MerchantParameters.value = response.data.formparameters.Ds_MerchantParameters;
        let inputDS_Signature = document.createElement('input');
        inputDS_Signature.type = 'text';
        inputDS_Signature.name = 'DS_Signature';
        inputDS_Signature.value = response.data.formparameters.Ds_Signature;

        formBizum.appendChild(inputDS_SignatureVersion);
        formBizum.appendChild(inputDs_MerchantParameters);
        formBizum.appendChild(inputDS_Signature);

        document.body.appendChild(formBizum);
        formBizum.submit();
      }else{
        if (debug) console.log ("[ERROR]: En peticion Bizum");
        if (debug) console.log ("ERROR: " + response.error.code);
        await 1;
      }
    }else if (paymethod === "googlepay"){
      if (debug) console.log("Iniciando pago googlepay");

      const response = await bookingGooglePay (cart.getCartProducts(),data, config.merchantURL, debug);
      setLoading('googlepay');

      if (debug) console.log("response:",response);
      if(!response.error) {
        let formGooglePay = document.createElement('form');
        formGooglePay.method = "POST";
        formGooglePay.action = response.data.redirectURL;
        let inputDS_SignatureVersion = document.createElement('input');
        inputDS_SignatureVersion.type = 'text';
        inputDS_SignatureVersion.name = 'Ds_SignatureVersion';
        inputDS_SignatureVersion.value = response.data.formparameters.Ds_SignatureVersion;
        let inputDs_MerchantParameters = document.createElement('input');
        inputDs_MerchantParameters.type = 'text';
        inputDs_MerchantParameters.name = 'Ds_MerchantParameters';
        inputDs_MerchantParameters.value = response.data.formparameters.Ds_MerchantParameters;
        let inputDS_Signature = document.createElement('input');
        inputDS_Signature.type = 'text';
        inputDS_Signature.name = 'Ds_Signature';
        inputDS_Signature.value = response.data.formparameters.Ds_Signature;
        let inputDS_XPayData = document.createElement('input');
        inputDS_XPayData.type = 'text';
        inputDS_XPayData.name = 'Ds_XPayData';
        inputDS_XPayData.value = response.data.paymentToken;
        let inputDS_XPayType = document.createElement('input');
        inputDS_XPayType.type = 'text';
        inputDS_XPayType.name = 'Ds_XPayType';
        inputDS_XPayType.value = 'Google';
        let inputDS_XPayOrigen = document.createElement('input');
        inputDS_XPayOrigen.type = 'text';
        inputDS_XPayOrigen.name = 'Ds_XPayOrigen';
        inputDS_XPayOrigen.value = 'WEB';

        formGooglePay.appendChild(inputDS_SignatureVersion);
        formGooglePay.appendChild(inputDs_MerchantParameters);
        formGooglePay.appendChild(inputDS_Signature);
        //formGooglePay.appendChild(inputDS_XPayData);
        //formGooglePay.appendChild(inputDS_XPayType);
        //formGooglePay.appendChild(inputDS_XPayOrigen);

        document.body.appendChild(formGooglePay);
        formGooglePay.submit();

      }else{
        if (debug) console.log ("[ERROR]: En peticion googlepay");
        if (debug) console.log ("ERROR: " + response.error.code);
        await 1;
      }
    }else{
      if (debug) console.log("No existe el metodo de pago");
    }

  });

  // Listado de Errores
  let errorClientList = [];
  let errorPaidList = [];
  Object.entries(errors).forEach(([key, value]) => {
    const html=<div key={key} className={styles.error}>{value.message}</div>;
    if (key == "creditcard" || key == "month" || key == "year" || key == "cvv" || key == "namecreditcard" || key=="errortpv"){
      errorPaidList.push(html);
    }else errorClientList.push(html);
  });

  const handleChangePaidInfo = (event) => {
    const { name, value } = event.target;
    let processValue;

    if (name == "creditcard"){
      processValue = value.replace(/ /g, "").split('').map( (x,i)=> (i>0 && i%4==0)? " "+x : x ).join('');
    }else{
      processValue=value;
    }
    setValue('creditcard', processValue, { shouldValidate: true });
  };

  return (
    <>
      <div className={styles.cartForm}>

        {/* ------ CLIENT INFO ------*/}
        <div className={styles.clientInfo}>
          <h2>{t('Datos de cliente')}</h2>

          <div className={styles.errors}>
            {errorClientList}
          </div>

          <div className={styles.inputs}>
            <input
              type="text"
              {...register("name", {
                required:{
                  value:true,
                  message:t('error.name.required')
                },
                pattern: {
                  value:/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/,
                  message:t('error.name.pattern')
                },
                })}
              placeholder={t('Nombre') + ' *'}
            />

            <input
              type="text"
              {...register("surname",{
                pattern:{
                  value:/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/,
                  message:t('error.surname.pattern')
                }
              })}
              placeholder={t('Apellidos')}
            />

            <input
              type="text"
              {...register("mail1", {
                required: {
                  value:true,
                  message:t('error.mail1.required')
                },
                pattern: {
                  value:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                  message:t("error.mail1.pattern")
                }})
              }
              placeholder={t('Email') + ' *'}
            />

            <input
              type="text"
              {...register("mail2", {
                required: {
                  value:true,
                  message:t('error.mail2.required')
                },
                pattern:{
                  value:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                  message:t('error.mail2.pattern')
                },
                validate: (value) => value === watch("mail1") || t('error.mail2.mismatch')
                })
              }
              placeholder={t('Repetir email')+ ' *'}
            />

            <input
              type="text"
              {...register("phone",{
                pattern:{
                  value:/^[\+]?[\d]{9,12}$/,
                  message:t('error.phone.pattern')
                }
              })}
              placeholder={t('Teléfono')}
            />

            <input
              type="text"
              {...register("room",{
                pattern:{
                 value:/^[A-Za-z0-9]+$/,
                 message:t('error.room.pattern')
                }
              })}
              placeholder={t('Habitación')}
            />

            <textarea
              {...register("observations",{
                pattern:{
                  value:/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s\.]+$/,
                  message:t('error.observations.pattern')
                }
              })}
              placeholder={t('Datos adicionales')}
            />

          </div>

          <div className={styles.cartInfo} dangerouslySetInnerHTML={{__html: t('cartinfo') }}></div>
        </div>

        {/* ------ PAID INFO ------*/}
        <div className={styles.paids}>

          {/* ------ CREDITCARD ------*/}
          <div className={styles.creditcard}>
            <div className={styles.title}>
              <input type="radio" {...register("paymethod")} value="creditcard" defaultChecked={true} />
              {t('Pago con tarjeta de crédito / Débito')}
              <i className={styles.creditcardicon}></i>
            </div>

            <div className={styles.errors}>
              {errorPaidList}
            </div>

            {paymethod === 'creditcard' ?
              <div className={styles.inputs}>
                <input
                  type="text"
                  className={styles.creditcard}
                  {...register("creditcard",{
                    required: {
                      value:true,
                      message:t("error.creditcard.required")
                    },
                    pattern:{
                      value:/^[0-9\s]+$/,
                      message:t("error.creditcard.pattern")
                    },
                    minLength: {
                      value:19,
                      message:t("error.creditcard.minlength")
                    }
                  })}
                  maxLength="19"
                  placeholder={t('Número de tarjeta') + " *"}
                  onChange={handleChangePaidInfo}
                />

                <div className={styles.expirydate}>

                  <input
                    type="text"
                    {...register("month",{
                      required: {
                        value:true,
                        message:t("error.month.required")
                      },
                      minLength: {
                        value:2,
                        message:t("error.month.minlength")
                      },
                      pattern:{
                        value:/^(00|01|02|03|04|05|06|07|08|09|10|11|12)+$/,
                        message:t("error.month.pattern")
                      }
                    })}
                    maxLength="2"
                    placeholder={t('Mes') + " *"}
                  />

                  <input
                    type="text"
                    {...register("year",{
                      required: {
                        value:true,
                        message:t("error.year.required")
                      },
                      minLength: {
                        value:2,
                        message:t("error.year.minlength")
                      },
                      min:{
                        value:24,
                        message:t("error.year.pattern")
                      }
                    })}
                    maxLength="2"
                    placeholder={t('Año')+ " *"}
                  />

                  <input
                    type="text"
                    {...register("cvv",{
                      required: {
                        value:true,
                        message:t("error.cvv.required")
                      },
                      minLength: {
                        value:3,
                        message:t("error.cvv.minlength")
                      },
                      pattern:{
                        value:/^[\d]+$/,
                        message:t("error.cvv.pattern")
                      }
                    })}
                    maxLength="3"
                    placeholder={t('CVV')+ " *"}
                  />

                </div>
                <input
                  type="text"
                  {...register("namecreditcard",{
                    required: {
                      value:true,
                      message:t("error.namecreditcard.required")
                    },
                    maxLength: 19,
                    pattern:{
                      value:/^[A-Za-z\.\s]+$/,
                      message:t("error.namecreditcard.pattern")
                    }
                  })}
                  placeholder={t('Nombre del titular')+ " *"}
                  disabled={paymethod == "creditcard" ? false:true}/>
                <input type="button" className={styles.btnsubmit} value={t('securepayment')} onClick={onSubmit} disabled={(paymethod !== "creditcard" || numProducts !== 0) ? false:true}/>
              </div>
              :false
            }
          </div>

          {/* --- PAGO SEGURO CON TARJETA ---*/}
          {/*<div className={styles.securecreditcard} id="securecreditcard">
            <div className={styles.title}>
              <input type="radio" {...register("paymethod")} value="securecreditcard" />
              {t('Pago con tarjeta de crédito / Débito')}
              <i className={styles.creditcardicon}></i>
            </div>
            {paymethod === 'securecreditcard' ?
              <div className={styles.inputs}>
                <div />
                <input type="button" className={styles.btnsubmit} value={t('securepayment')} onClick={onSubmit} disabled={(paymethod !== "securecreditcard" || numProducts !== 0) ? false:true} />
              </div>
              :false
            }
          </div>*/}

          {/* ------ PAYPAL ------*/}
          <div className={styles.paypal} id="paypal">
            <div className={styles.title}>
              <input type="radio" {...register("paymethod")} value="paypal" />
              {t('Pago con paypal')}
              <i className={styles.paypalicon}></i>
            </div>
            {paymethod === 'paypal' ?
              <div className={styles.inputs}>
                <div />
                <input type="button" className={styles.btnsubmit} value={t('securepayment')} onClick={onSubmit} disabled={(paymethod !== "paypal" || numProducts !== 0) ? false:true} />
              </div>
              :false
            }
          </div>

          {/* ------ BIZUM ------*/}
          <div className={styles.bizum} id="bizum">
            <div className={styles.title}>
              <input type="radio" {...register("paymethod")} value="bizum" />
              {t('Pago con')}
              <i className={styles.bizumicon}></i>
            </div>
            {paymethod === 'bizum' ?
              <div className={styles.inputs}>
                <div />
                <input type="button" className={styles.btnsubmit} value={t('securepayment')} onClick={onSubmit} disabled={(paymethod !== "bizum" || numProducts !== 0) ? false:true} />
              </div>
              :false
            }
          </div>

          {/* ------ GOOGLEPAY ------*/}
          <div className={styles.googlepay} id="googlepay">
            <div className={styles.title}>
              <input type="radio" {...register("paymethod")} value="googlepay" />
              {t('Google Pay')}
              <i className={styles.googlepayicon}></i>
            </div>
            {paymethod === 'googlepay' ?
              <div className={styles.inputs}>
                <div />
                <input type="button" className={styles.btnsubmit} value={t('securepayment')} onClick={onSubmit} disabled={(paymethod !== "googlepay" || numProducts !== 0) ? false:true} />
              </div>
              :false
            }
          </div>

          <div className={styles.conditions}>{t('* Al hacer click aceptas las condiciones de compra')}</div>

        </div>
      </div>

      {/* ---- MODAL PAY ---- */}
      {loading !== false &&
        <div className={styles.modalPay}>
          <div className={styles.modalPayBackground}>&nbsp;</div>
          <div className={styles.modalPayContent}>
            <div className={styles.modalPayImg}>
              {loading === 'creditcard' && <img src={imgCreditcard} />}
              {loading === 'securecreditcard' && <img src={imgCreditcard} />}
              {loading === 'paypal' && <img src={imgPaypal} />}
              {loading === 'bizum' && <img src={imgBizum} />}
              {loading === 'googlepay' && <img src={imgGooglePay} />}
            </div>
            <div className={styles.modalPayText}>{t('Comunicando con el banco para realizar el pago')}</div>
            <div className={styles.modalPayText}>{t('Por favor no recargue la pagina')}</div>
            <div className={styles.modalPayText}>{t('Esta operacion puede durar varios minutos')}</div>
            <div className={styles.modalPayGif}>&nbsp;</div>
          </div>
        </div>
      }
    </>
  );
}

export default VTCartForm;
